import { MODAL_TYPE_V2, MODAL_SUB_TYPE_V2 } from '../constants.js';

function showDecision(_ref) {
  var modalType = _ref.modalType;
  return [MODAL_TYPE_V2.INFORMATION, MODAL_TYPE_V2.DECISION].indexOf(modalType) > -1;
}
function showFeedBack(_ref2) {
  var modalType = _ref2.modalType,
      modalSubType = _ref2.modalSubType;
  return showDecision({
    modalType: modalType
  }) && Object.values(MODAL_SUB_TYPE_V2).indexOf(modalSubType) > -1;
}
function showFooter(_ref3) {
  var modalType = _ref3.modalType;
  return modalType !== MODAL_TYPE_V2.INFORMATION;
}
function showSelection(_ref4) {
  var modalType = _ref4.modalType;
  return modalType === MODAL_TYPE_V2.SELECTION;
}
function showForm(_ref5) {
  var modalType = _ref5.modalType;
  return modalType === MODAL_TYPE_V2.FORM;
}

export { showDecision, showFeedBack, showFooter, showForm, showSelection };
//# sourceMappingURL=helpers.js.map
